import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Field } from 'redux-form';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Tooltip
} from '@material-ui/core';
import CustomInput from '../../../../../utils/redux-forms-custom-fields/CustomInput';
import CustomInputCheckbox from '../../../../../utils/redux-forms-custom-fields/CustomInputCheckbox';
const ViewerTiers = ({
  fields, 
  meta: { error },
  questForm,
  parametersSubTab,
  streamingQuest
}) => {
  const questStarted = React.useMemo(() => {
    if (!questForm?.values?.startDateTime) return false;
    return moment(questForm.values.startDateTime).diff(moment(Date.now())) < 0;
  }, [questForm?.values?.startDateTime]);
  
  if (parametersSubTab !== 0) return null;

  return (
    <section className="WhiteListWrapper">
      <TableContainer>
        <Table>
          {questForm?.values?.viewerTiers?.length > 0 && (
            <TableHead>
              <TableRow>
                <TableCell align="center">Spots Available</TableCell>
                {streamingQuest && <TableCell align="center">Min. Avg. Viewers</TableCell>}
                <TableCell align="center">
                  $ Amount &nbsp;
                  <Tooltip title='Put "0" for no message. Put "-1" for free key. Put "-2" for points.' placement="top">
                    <i className="fa fa-info-circle" />
                  </Tooltip>
                </TableCell>
                <TableCell align="center">Noiz Points</TableCell>
                <TableCell align="center">Tier Goal</TableCell>
                <TableCell align="center">Enable Goal</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {fields.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Field
                    name={`${item}.spotsAvailable`}
                    id={`${item}.spotsAvailable`}
                    type="text"
                    component={CustomInput}
                    placeholder="Spots Available"
                    onlyNumbers="true"
                  />
                </TableCell>
                {streamingQuest && (
                  <TableCell>
                    <Field
                      name={`${item}.minimumAverageViewers`}
                      id={`${item}.minimumAverageViewers`}
                      type="text"
                      component={CustomInput}
                      placeholder="Minimum Average Viewers"
                      onlyNumbers="true"
                    />
                  </TableCell>
                )}
                <TableCell>
                  <Field
                    name={`${item}.paymentAmount`} 
                    id={`${item}.paymentAmount`}
                    type="text"
                    component={CustomInput}
                    placeholder="Payment Amount"
                  />
                </TableCell>
                <TableCell>
                  <Field
                    name={`${item}.noizPoints`}
                    id={`${item}.noizPoints`}
                    type="text" 
                    component={CustomInput}
                    placeholder="ARKade Ticket"
                    onlyNumbers="true"
                  />
                </TableCell>
                <TableCell>
                  <Field
                    name={`${item}.goal`}
                    id={`${item}.goal`}
                    type="text"
                    component={CustomInput}
                    placeholder="Goal Description"
                  />
                </TableCell>
                <TableCell align="center">
                  <Field
                    name={`${item}.goalEnabled`}
                    id={`${item}.goalEnabled`}
                    type="checkbox"
                    component={CustomInputCheckbox}
                  />
                </TableCell>
                <TableCell align="center">
                  {!questStarted && (
                    <button
                      className="RepeaterWrapper__item-remove"
                      type="button"
                      onClick={() => {
                        if (window.confirm('Are you sure you want to remove this tier?')) {
                          fields.remove(index);
                        }
                      }}
                    >
                      <i className="fa fa-trash" />
                    </button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {error && <span className="RepeaterWrapper__error">{error}</span>}
      
      {(streamingQuest || (!streamingQuest && !questForm?.values?.viewerTiers?.length)) && (
        <button 
          className="RepeaterWrapper__add-item" 
          type="button" 
          onClick={() => fields.push({ minimumAverageViewers: 0 })}
        >
          Add {!streamingQuest ? 'A Payment Amount' : 'Another Viewer Tier'} 
        </button>
      )}
    </section>
  );
};

ViewerTiers.propTypes = {
  fields: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  questForm: PropTypes.object,
  parametersSubTab: PropTypes.number.isRequired,
  streamingQuest: PropTypes.bool
};

export default React.memo(ViewerTiers);